import React from "react";
import { Clock } from "lucide-react";

export function BreachClock({ incident, compact = false }) {
  if (!incident.personal_data_breach) return compact ? <span className="text-xs text-slate-400">—</span> : null;
  if (incident.regulator_notified_at) return <span className="text-xs text-emerald-700" data-testid="breach-clock-done">Regulator notified</span>;
  if (incident.regulator_not_required_reason) return <span className="text-xs text-slate-500">Not required</span>;
  const hours = Math.round((new Date(incident.regulator_deadline) - Date.now()) / 36e5);
  const overdue = hours < 0;
  const text = overdue ? `${-hours}h overdue` : `${hours}h left to notify regulator`;
  if (compact) return <span className={`text-xs font-medium ${overdue ? "text-red-600" : "text-amber-700"}`} data-testid="breach-clock-compact">{text}</span>;
  return (
    <div className={`flex items-center gap-2 p-3 rounded-sm border text-sm ${overdue ? "bg-red-50 border-red-200 text-red-800" : "bg-amber-50 border-amber-200 text-amber-900"}`} data-testid="breach-clock">
      <Clock size={16} /> GDPR 72-hour notice: {text} (deadline {new Date(incident.regulator_deadline).toLocaleString("en-GB")})
    </div>
  );
}
